import CardColumn from './CardColumn';
import local from './Stakeholder.module.scss';

const SHELL_QUALITY_MANUAL =
  'https://www.shell.com/content/dam/shell/assets/en/business-functions/my-work-space/documents/supplier-quality-manual-versionnine.pdf#vanity-aHR0cHM6Ly93d3cuc2hlbGwuY29tL2x1YnJpY2FudHNTUU0uaHRtbA';
const STAKEHOLDER_LETTER = [
  {
    content: (
      <p style={{marginTop: '-10px'}}>
        On behalf of 3M, I am writing to express our support for mandatory
        participation in the IAF's global certification database IAFCertSearch.
        We believe IAFCertSearch is a tool which is greatly needed for effective
        international and domestic commercial transactions.
      </p>
    ),
    company: (
      <>
        <p className="mb-0">
          <strong>Ranjit Thakur</strong>
        </p>
        <p>Energy Management Business Director, 3M</p>
      </>
    ),
    img: '/p/landing/company-logos/3m.svg',
    css: {
      height: '50px',
      width: 'auto',
      marginLeft: '-30px',
    },
  },
  {
    content: (
      <>
        <p style={{marginTop: '-10px'}}>
          Global trade relies on swift exchange of digital information. Complex
          global supply chains are commonplace in today's world and so buyers
          and suppliers expect that certification bodies and accreditation
          bodies will work together to facilitate digital verification of
          accredited certification.
        </p>
        <p>
          We urge you to support the proposal to make the IAF CertSearch
          Database a mandatory requirement for all certification bodies.
        </p>
      </>
    ),
    company: (
      <>
        <p className="mb-0">
          <strong>Crystal Sharp</strong>
        </p>
        <p>Global Quality Manager, Dupont</p>
      </>
    ),
    img: '/p/landing/company-logos/dupont.svg',
  },

  {
    content: (
      <p style={{marginTop: '10px'}}>
        Shell Lubricants is the global leader in branded lubricants and markets
        products. We offer our customers high-performance products. Hence,
        quality is a key component in our Brand. As per our{' '}
        <a
          href={SHELL_QUALITY_MANUAL}
          rel="noopener noreferrer"
          target="_blank"
          className={local['letters__link']}
        >
          Supplier Quality Manual
        </a>
        , we expect that all our suppliers hold accredited certifications
        ISO9001 as a minimum and more depending on the requirements. Now we
        start to verify these certifications through IAF CertSearch. IAF
        CertSearch digital solution provide a simple fast, and reliable for us
        to verify the certification at any time! And with real-time monitoring,
        we’re immediately informed of any changes to certification
        statuses—enhancing our oversight like never before.
      </p>
    ),
    company: (
      <>
        <p className="mb-0">
          <strong>Global Supplier Assurance Manager</strong>
        </p>
        <p>Shell</p>
      </>
    ),
    img: '/p/landing/company-logos/shell.svg',
    css: {
      width: '90px',
      marginLeft: '-60px',
    },
  },
  {
    content: (
      <p>
        In these extraordinary times, we write to you to call for urgent action
        to support essential changes to the IAF CertSearch Database.
      </p>
    ),
    company: (
      <>
        <p className="mb-0">
          <strong>Beth Ford</strong>
        </p>
        <p>Sr Sourcing Manager, AT&T Services Inc.</p>
      </>
    ),
    img: '/p/landing/company-logos/at-t.svg',
  },
  {
    content: (
      <p style={{marginTop: '-20px'}}>
        To ensure accreditation remains relevant and valuable in this modern
        world, and to reduce technical barriers to trade, we urge you to support
        the proposal to make the IAF CertSearch database a mandatory requirement
        for all certification bodies, while also adhering to the essential
        requirement to ensure data management. Our vision is that all accredited
        certifications will be included in the database for accurate record
        keeping and validation.
      </p>
    ),
    company: (
      <>
        <p className="mb-0">
          <strong>Thomas Kaiser</strong>
        </p>
        <p>Supply Chain & Quality Manager, Airbus</p>
      </>
    ),
    img: '/p/landing/company-logos/airbus.svg',
  },
  {
    content: (
      <p style={{marginTop: '-20px'}}>
        I am writing to express our support for global participation in IAF’s
        global certification database IAF CertSearch.
      </p>
    ),
    company: (
      <>
        <p className="mb-0">
          <strong>Kevin Bourne</strong>
        </p>
        <p>Managing Director, Head of Investment Research, S&P Global</p>
      </>
    ),
    img: '/p/landing/company-logos/s-p-global.svg',
  },
];

export default function CustomCard(props) {
  const {isMobile} = props;
  const selectedLetters = [2, 1, 4].map((i) => STAKEHOLDER_LETTER[i]);

  return (
    <>
      {isMobile ? (
        <CardColumn
          list={selectedLetters}
          start={0}
          end={3}
          className={`${isMobile} ? 'mt-3' : 'mt-5'`}
        />
      ) : (
        <>
          <CardColumn
            list={STAKEHOLDER_LETTER}
            start={0}
            end={2}
            className="mt-5"
          />
          <CardColumn list={STAKEHOLDER_LETTER} start={2} end={4} />
          <CardColumn
            list={STAKEHOLDER_LETTER}
            start={4}
            end={6}
            className="mt-5"
          />
        </>
      )}
    </>
  );
}
